import React from 'react';

import { Typography } from 'ucl/components/text/Typography';

import { IServerOrder } from '@rbi-ctg/menu';
import { t, tRich } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { platform } from 'utils/environment';

import { useActiveTieredDeliveryFees } from '../hooks/use-active-tiered-delivery-fees';

import FreeDeliveryProgress from './free-delivery-progress';

const FreeDeliveryProgressContainer: React.FC<React.PropsWithChildren<{
  serverOrder: IServerOrder | null;
  isLoading: boolean;
}>> = ({ serverOrder, isLoading }) => {
  const { formatCurrencyForLocale } = useUIContext();
  const subTotal = serverOrder?.cart.subTotalCents ?? 0;
  const { freeDeliveryThreshold } = useActiveTieredDeliveryFees({
    subTotalCents: subTotal,
    platform: platform(),
  });

  const shouldShowFreeDeliveryBar = !!freeDeliveryThreshold;

  if (!shouldShowFreeDeliveryBar) {
    return null;
  }

  const freeDeliveryPercentageComplete = Math.min(subTotal / freeDeliveryThreshold, 1) * 100;
  const amountRemaining = freeDeliveryThreshold - subTotal;

  return (
    <FreeDeliveryProgress
      isLoading={isLoading}
      isFreeDelivery={freeDeliveryPercentageComplete === 100}
      freeDeliveryPercentageComplete={freeDeliveryPercentageComplete}
      titleLabel={t('freeDeliveryOverAmount', {
        amount: formatCurrencyForLocale(freeDeliveryThreshold),
      })}
      freeDeliveryReachedLabel={t('youQualifyFreeDelivery')}
      freeDeliveryInProgressLabel={tRich('youreXAwayFromFreeDelivery', {
        amount: <Typography bold>{formatCurrencyForLocale(amountRemaining)}</Typography>,
      })}
    />
  );
};

export default FreeDeliveryProgressContainer;
